function e(e,t,n,c){const s=new CustomEvent(t,Object.assign({bubbles:!0,cancelable:!1,composed:!0,detail:n||{}},c));return e.dispatchEvent(s),s}export{e as emitEvent};
